<template>
    <Chart @getData="getData">
        <template #v>
            <section class="content_table">
                <div class="tit">规模以上工业个数、增加值、利润</div>
                <div class="wbox">
                    <div class="tbox">
                        <span>年份</span>
                        <span>工业个数</span>
                        <span>工业增加量</span>
                        <!-- <span>工业利润</span> -->
                    </div>
                    <div
                        :class="['stbox',index%2==0?'':'bk']"
                        v-for="(item, index) in list"
                        :key="index"
                    >
                        <span>{{ item.time }}</span>
                        <span>{{ item.dataArr[0].value }}{{item.dataArr[0].units}}</span>
                        <span>{{ item.dataArr[1].value }}{{item.dataArr[1].units}}</span>
                        <!-- <span>{{ item.dataArr[2].value }}{{item.dataArr[2].units}}</span> -->
                    </div>
                </div>
            </section>
        </template>
    </Chart>
</template>

<script>
import Chart from "../components/chart";
export default {
    name: "",
    data() {
        return {
            list: [],
        };
    },
    methods: {
        getData(plan, echarts,times) {
            var url =
                this.urlobj.dx_jjfxty +
                `?tableName=rlt_40year_item_value&times=${times}&itemid=17,18,19`;
            this.$get(url).then((res) => {
                // console.log(res)
                this.list = res.rows[0].data.slice(-5);
            });
        },
    },
    created() {},
    components: { Chart },
};
</script>

<style lang="less" scoped>
.tit {
    font-size: 16px;
    color: #fff;
    box-sizing: border-box;
    padding: 10px 0 0 20px;
}
span {
    // width: 24%
    width: 33%
}
.wbox {
    margin: 20px 0 0 0;
}
.tbox {
    display: flex;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    color: #00aada;
}
.stbox {
    margin: 3px 0;
    display: flex;
    height: 22px;
    line-height: 22px;
    text-align: center;
    font-size: 16px;
    span:nth-child(1){
        color: #e2e6f1
    }
    span:nth-child(2){
        color: #01ff02
    }
    span:nth-child(3),span:nth-child(4){
        color: #e0d018
    }
    
}
.content_table {
    height: 250px;
    overflow: hidden;
}
.bk {
    background: #233c7c; 
}
</style>
